<template>
  <div>
    <Form ref="dataForm" :model="dataForm">
      <Row>
        <Col span="24">
          <FormItem label="退回到:" prop="rollbackAuditTaskNodeId">
            <Select v-model="dataForm.rollbackAuditTaskNodeId" placeholder="请选择">
              <Option v-for="item in selRollbackNodeList" :value="item.taskNodeId" :key="item.taskNodeId">{{ item.taskNodeName }}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="24">
          <FormItem label="退回原因:" prop="auditNote">
            <Input v-model.trim="dataForm.auditNote" type="textarea" :rows="4" :maxlength="300" placeholder="最多300字"></Input>
          </FormItem>
        </Col>
      </Row>
    </Form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataForm: {
        rollbackAuditTaskNodeId: '',
        auditNote: ''
      }
    };
  },
  props: {
    selRollbackNodeList: {
      type: Array,
      default: []
    }
  }
};
</script>

<style>

</style>
